<template>
    <div class="inline-flex items-center gap-2 rounded-md border px-3 py-2" :class="badgeClasses">

        <slot name="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"/></svg>
        </slot>

        <p class="mb-0 text-sm font-medium" :class="textColor">{{ label }}</p>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    label: {
        type: String,
        required: true
    },
    variant: {
        type: String,
        default: 'gray',
        validator: (value) => ['gray', 'blue', 'green', 'yellow', 'red'].includes(value)
    }
})

const badgeClasses = computed(() => {
    const variants = {
        gray: 'border-gray-300 bg-gray-50 text-gray-600',
        blue: 'border-blue-200 bg-blue-50 text-blue-600',
        green: 'border-green-200 bg-green-50 text-green-600',
        yellow: 'border-yellow-200 bg-yellow-50 text-yellow-600',
        red: 'border-red-200 bg-red-50 text-red-600'
    }
    return variants[props.variant]
})

const textColor = computed(() => {
    const colors = {
        gray: 'text-gray-700',
        blue: 'text-blue-900',
        green: 'text-green-900',
        yellow: 'text-yellow-900',
        red: 'text-red-900'
    }
    return colors[props.variant]
})
</script>